import { render, staticRenderFns } from "./BranchesActivityList.vue?vue&type=template&id=48e68945&"
import script from "./BranchesActivityList.vue?vue&type=script&lang=js&"
export * from "./BranchesActivityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports